import { FormError } from '@/types/global';

export function ValidateTextfield(input: HTMLFormElement, errorMessages: Array<FormError>): Array<string> {
  const errors = [] as Array<string>;
  errorMessages.forEach((error: FormError) => {
    const message = error.message;
    if (error.type === 'required') {
      if (input && input.value === '') {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
    if (input.value !== '' && error.type === 'email') {
      const emailPattern = new RegExp(
        /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
      ); // regex from vuelidate
      if (!emailPattern.test(input.value)) {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
    if (input.value !== '' && error.type === 'alpha') {
      const alphaPattern = new RegExp(/^[ÀÂÆÇÈÉÊËÎÏÔÙÛÜàâæçèéêëäöüÄÖÜßa-zA-Z]*$/); // regex from vuelidate extended with special unicode characters
      if (!alphaPattern.test(input.value)) {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
    if (input.value !== '' && error.type === 'alphanum') {
      const alnumPattern = new RegExp(/^[\n\r\., ÀÂÆÇÈÉÊËÎÏÔÙÛÜàâæçèéêëäöüÄÖÜßa-zA-Z0-9]*$/); // regex from vuelidate extended with special unicode characters
      if (!alnumPattern.test(input.value)) {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
    if (input.value !== '' && error.type === 'numeric') {
      const numPattern = new RegExp(/^\d*(\.\d+)?$/); // regex from vuelidate
      if (!numPattern.test(input.value)) {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
    if (input.value !== '' && error.type === 'phone') {
      const numPattern = new RegExp(/^[\+]?[(]?[- 0-9]+[)]?$/);
      if (!numPattern.test(input.value)) {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
  });
  return errors;
}

export function ValidateRadioGroup(radios: Array<HTMLFormElement>, errorMessages: Array<FormError>): Array<string> {
  const errors = [] as Array<string>;
  errorMessages.forEach((error: FormError) => {
    if (error.type === 'required') {
      const message = error.message;
      const input = radios.filter(radio => radio.checked);
      if (input) {
        errors.splice(errors.indexOf(message));
      } else {
        errors.push(message);
      }
    }
  });
  return errors;
}

export function ValidateSelect(input: HTMLFormElement, errorMessages: Array<FormError>): Array<string> {
  const errors = [] as Array<string>;
  (errorMessages as Array<FormError>).forEach((error: FormError) => {
    if (error.type === 'required') {
      const message = error.message;
      if (input && input.value === '') {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
  });
  return errors;
}

export function ValidateCheckbox(input: HTMLFormElement, errorMessages: Array<FormError>): Array<string> {
  const errors = [] as Array<string>;
  (errorMessages as Array<FormError>).forEach((error: FormError) => {
    if (error.type === 'required') {
      const message = error.message;
      if (input && !input.checked) {
        errors.push(message);
      } else {
        errors.splice(errors.indexOf(message));
      }
    }
  });
  return errors;
}
